import { useCallback, useEffect } from "react"
import { batch, useSignal } from "@preact/signals-react"
import { postSubmit } from "@ui-seeker/utils"

import { companyUsers, dateRange } from "@signals"
import { BACKEND_APIS } from "@constants"
import { monthSearches } from "Pages/Main/Home/@signals"


export default function useSearchAnalyticsMonthInfo() {
	const columnChartData = useSignal({})
	const isMonthLoading = useSignal(false)

	const getMonthInfo = useCallback(() => {
		isMonthLoading.value = true
		postSubmit(`${BACKEND_APIS.SEARCH_ANALYTICS}/month`, {
			uid: companyUsers.value
		}).then(res => {
			batch(() => {
				monthSearches.value = res.monthSearches
				columnChartData.value = {
					bookingDates: res.bookingDates,
					results: res.results,
					series: res.series
				}
				isMonthLoading.value = false
			})
		}).catch(() => {
			isMonthLoading.value = false
		})
	}, [JSON.stringify(companyUsers.value)])

	useEffect(() => {
		getMonthInfo()
	}, [JSON.stringify(companyUsers.value), JSON.stringify(dateRange.value)])

	return {
		columnChartData: columnChartData.value,
		isMonthLoading: isMonthLoading.value,
	}
}